import React, { Component } from 'react';
import { Progress, Table, Button } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import Panel from '../../../shared/components/Panel';

import { _getListings, _getTract } from './apicalls';

import SubFilter from './SubFilter';
import { Link } from "react-router-dom";

import { 
	_unitFilters	
} from "./filters";

const colors = {
	Low: '#ff4861',
	Moderate: '#f6da6e',
    Middle: '#70bbfd',
    Upper: '#4ce1b6',
};

class LatestClosings extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
  };
 
  
  constructor() {
    super();
    this.state = {
      data: false,
    };
  }

  
  componentDidMount() {
	 const { type } = this.props;
	_getListings('price:[200000 TO 100000000]', type, { callback: (result) => { 
		this.setState({ data: result.docs });
	} });
  }
  
  shouldComponentUpdate(nextProps, nextState) {	  
	  const { type } = this.props;
	  return type !== nextProps.type || JSON.stringify(this.state.data) !== JSON.stringify(nextState.data);
  }
  
 componentDidUpdate() {
	 const { type } = this.props;
	 _getListings('price:[200000 TO 100000000]', type, { callback: (result) => { 
		this.setState({ data: result.docs });
	} });
  }
   _toggle = (source) => {
	  let checkboxes = document.getElementsByName('add');
	  for(var i=0, n=checkboxes.length;i<n;i++) {
	    checkboxes[i].checked = source.currentTarget.checked;
	  }
	}
	
  render() {
      const { t } = this.props;
      
      const { data } = this.state;
      const profileColors = ['#9decd6', '#9eb3c1', '#f9b2b2', '#66abf5'];
      
      if (!data) return null;
	
	  return (
		  <Panel lg={12} xl={12} md={12} title={'RESIDENTIAL SALES LISTINGS'} subhead={'Latest properties for sale in selected income census tracts'}>
		  	<SubFilter _filters={_unitFilters} subFilters={{}} size={'xsmall'} />
		  	<div style={{textAlign:"right"}}>
		  		 <Button color="primary" type="submit" style={{fontSize:12,margin:"0px 0px"}}>Download List</Button>
		  		 
		  	</div>
		    <Table responsive striped className="dashboard__table-orders">
		      <thead>
		         <tr>	
		          <th style={{whiteSpace:'nowrap'}}><input type="checkbox" onClick={(e) => this._toggle(e)} /></th>
		          <th>Agent Name</th>		          
		          <th>Listed</th>	          		          
		          <th>Tract Income</th>		          
		          <th>Propert Type</th>		          		          		          
		          <th>Address</th>		          
		          <th>Price</th>
		          <th />
		        </tr>
		      </thead>
		      <tbody>
		       {data.map(row => 
                {
	               const censusTract = _getTract(row.borough_code, row.census_tract);
	               const color = censusTract && colors[censusTract.income] ? colors[censusTract.income] : '#CCC';
				   const agents = row.contacts_json ? JSON.parse(row.contacts_json) : [];
			       return (
				       <tr>
				          <td><input type="checkbox" name="add" /></td>
				       	  <td className="dashboard__table-orders-title">
				       	    <div className="dashboard__table-orders-img-wrap">
				          		<div className="" style={{ background: profileColors[Math.floor(Math.random() * profileColors.length)], textAlign: 'center', lineHeight: '32px', fontSize:'15px', color: '#FFF' }}>{agents[0] && agents[0].name ? agents[0].name[0] : ''}</div>
				          	</div>
				            <div>
				            	<span>{agents[0] ? agents[0].name : ''}</span><br/>
					              		
				          
								<span style={{marginTop:3, display:'inline-block', fontSize:'11px', textTransform:'capitalize' }}>{row.broker_display_name ? row.broker_display_name : ''}</span><br/>
								<a href="" style={{marginTop:7,fontSize:11}}>See Profile &raquo;</a>
				            
				            </div>
				            
				          </td>	
				          				       	  
				          <td style={{ textTransform:'capitalize' }}>{moment(row.active_date_start).fromNow()}</td>
				          <td>
				          	<span style={{ width:'10px', height:'10px', borderRadius:'50%', display:'inline-block', background:color, marginRight: '10px', }} />
				          	{censusTract.income || 'Unknown'}
				          </td>				          			         
				       	  <td style={{ textTransform:'capitalize' }}>{row.ownership_type.replace('-', ' ')}</td>				       	  				       	  
				          <td style={{ textTransform:'capitalize' }}>
				          <a href={`https://marketproof.com/building/${row.borough}/${row.neighborhood[0]}/${row.building.substring(4)}/${row.address_2_normalized ? row.address_2_normalized.replace(' ', '-') : ''}?tab=listing`} target="_blank" rel="noopener noreferrer">{row.display_full_street_address}{row.address_2_normalized ? ', ' + row.address_2_normalized : ''}</a><br /> 
				          	<span style={{ fontSize:'11px' }}>{row.neighborhood[0]}, {row.borough}</span></td>
				          <td>{['$', new Intl.NumberFormat('en').format(row.price)].join('')}</td>				          
				         
				          <td><Button color="primary" type="submit" style={{fontSize:12,margin:"0px 20px"}}>Save</Button></td>
				        </tr>

						); 
                }) 
		       }
		      </tbody>
		    </Table>
		    <Link to={`/`} className="see-more">See More &raquo;</Link>
		  </Panel>
		  );
	}
}

export default connect(state => ({
  cryptoTable: state.cryptoTable.items,
  rtl: state.rtl,
  theme: state.theme,
}))(withTranslation('common')(LatestClosings));
